import styled from "styled-components";

type ContainerProps = {
  isDarkMode: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  padding: 4rem 6rem;
  gap: 1rem;
  background: ${(props) => (!props.isDarkMode ? 'var(--color-white)' : 'var(--gray-darkest)')};
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.isDarkMode ? 'var(--color-white)' : 'var(--gray-darkest)')};

  @media (max-width: 75rem) {
    flex-wrap: wrap;
    padding: 0;
  }
`;

export const StyledImage = styled.img`
  max-width: 60%;

  @media (max-width: 48rem) {
    max-width: 100%;
  }
`;

export const PagerContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: var(--color-white);
  width: 100%;
  padding: 2rem 0;

  @media (max-width: 48rem) {
    justify-content: center;
    padding: 2rem 1rem;
  }
`;
export const PagerNavigationContainer = styled.div`
  width: 35em;
  margin-right: 1em;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    max-width: 300px;
  h3 {
    text-transform: uppercase;
    text-align: center;
    margin-top: 10px !important;
    font-weight: bold;
    line-height: 1.1;
  }

  p {
    text-align: center;
  }
    
  @media (max-width: 125rem) {

    flex-direction: column;
    padding: 2rem;
    max-width:80%;
    
    p, h3 {
    text-align: center;
    line-height: 1.2;
    
    h3 {
    margin: 0 !important;
    }
    }
    @media (max-width: 48rem){
    padding: 0;
    h3, span {
    font-size: 2rem;
    }
    p {
    margin: 2rem 0 4rem 0;
    }
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 1rem;
  @media (max-width: 75rem) {
    justify-content: center;
    margin-bottom: 4rem;
  }
  @media (max-width: 48rem) {
    flex-direction: column;
    gap: 1.5rem;
  }
`;
